import { isListType, isNonNullType } from 'graphql';

const unwrapFieldType = (fieldType) => {
  let currentType = fieldType;
  let isRequired = false;
  let isList = false;

  if (isNonNullType(currentType)) {
    isRequired = true;
    currentType = currentType.ofType;
  }

  if (isListType(currentType)) {
    isList = true;
    currentType = currentType.ofType;

    if (isNonNullType(currentType)) {
      currentType = currentType.ofType;
    }
  }

  return {
    isList,
    isRequired,
    type: currentType
  };
};

export default unwrapFieldType;
